<!-- <p>user-dashboard works!</p> -->
<mat-stepper [linear]="false" #stepper>
  <mat-step>
    <ng-template matStepLabel>Security</ng-template>
    <section *ngIf="role == 'security'">
      <mat-grid-list cols="3" rowHeight="150px" [gutterSize]="'15px'">
        <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="incident-counter-card"
            ><mat-card-header class="incident-counter-card-header"
              >TOTAL INCIDENTS</mat-card-header
            >
            <mat-card-content class="incident-counter-card-content">
              <div
                *ngIf="!orgData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  orgData.incidentDetails.totalIncidents
                    ? orgData.incidentDetails.totalIncidents
                    : 0
                }}
              </div>
              <div *ngIf="orgData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">visibility</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
        <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="incident-counter-card"
            ><mat-card-header class="incident-counter-card-header"
              >TOTAL OPEN</mat-card-header
            >
            <mat-card-content class="incident-counter-card-content">
              <div
                *ngIf="!orgData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  orgData.incidentDetails.totalOpen
                    ? orgData.incidentDetails.totalOpen
                    : 0
                }}
              </div>
              <div *ngIf="orgData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <i class="fa-solid fa-circle-exclamation counter-icon"></i>
            </mat-card-content> </mat-card
        ></mat-grid-tile>
        <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="incident-counter-card"
            ><mat-card-header class="incident-counter-card-header"
              >TOTAL CLOSED</mat-card-header
            >
            <mat-card-content class="incident-counter-card-content">
              <div
                *ngIf="!orgData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  orgData.incidentDetails.totalClosed
                    ? orgData.incidentDetails.totalClosed
                    : 0
                }}
              </div>
              <div *ngIf="orgData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">verified_user</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
      </mat-grid-list>
      <mat-divider></mat-divider>
      <mat-grid-list cols="3" rowHeight="150px" [gutterSize]="'15px'">
        <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="visitor-counter-card"
            ><mat-card-header class="visitor-counter-card-header"
              >TOTAL VISITOR</mat-card-header
            >
            <mat-card-content class="visitor-counter-card-content">
              <div
                *ngIf="!orgData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  orgData.visitorDetails.totalVisitor
                    ? orgData.visitorDetails.totalVisitor
                    : 0
                }}
              </div>
              <div *ngIf="orgData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">visibility</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
        <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="visitor-counter-card"
            ><mat-card-header class="visitor-counter-card-header"
              >TOTAL UNVERIFIED</mat-card-header
            >
            <mat-card-content class="visitor-counter-card-content">
              <div
                *ngIf="!orgData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  orgData.visitorDetails.totalUnverified
                    ? orgData.visitorDetails.totalUnverified
                    : 0
                }}
              </div>
              <div *ngIf="orgData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <i class="fa-solid fa-circle-exclamation counter-icon"></i>
            </mat-card-content> </mat-card
        ></mat-grid-tile>
        <mat-grid-tile [colspan]="screenInfo == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="visitor-counter-card"
            ><mat-card-header class="visitor-counter-card-header"
              >TOTAL VERIFIED</mat-card-header
            >
            <mat-card-content class="visitor-counter-card-content">
              <div
                *ngIf="!orgData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  orgData.visitorDetails.totalVerified
                    ? orgData.visitorDetails.totalVerified
                    : 0
                }}
              </div>
              <div *ngIf="orgData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">verified_user</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
      </mat-grid-list>
      <mat-divider></mat-divider>
    </section>
    <section
      *ngIf="showPreviewSection && screenInfo !== ScreenType.Mobile && !isKiosk"
      class="user-dashboard-preview-section"
    >
      <mat-grid-list
        [cols]="
          screenInfo === ScreenType.Desktop || screenInfo === ScreenType.Tablet
            ? '2'
            : '1'
        "
        rowHeight="100px"
        gutterSize="10px"
      >
        <mat-grid-tile rowspan="2">
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h4 *ngIf="screenInfo === ScreenType.Desktop">
                Recent Incidents
              </h4>
              <h5 *ngIf="screenInfo === ScreenType.Tablet">Recent Incidents</h5>
            </div>
            <div
              *ngIf="recentIncidents.length == 0"
              class="preview-content-empty"
            >
              No recent incident
            </div>
            <div *ngIf="recentIncidents.length > 0" class="preview-content">
              <section class="mobile-table-card-wrapper">
                <div
                  *ngFor="let incident of recentIncidents"
                  class="mobile-table-card-container"
                >
                  <div class="card-content">
                    <div>
                      Incident Id :
                      <b> {{ incident.incidentId.split("-")[0] }}</b>
                    </div>
                    <div>
                      Date :
                      <b>{{
                        getFormatedDate(incident.eventCreateDate)
                          | date : "dd/MM/yy, hh:mm:ss a'"
                      }}</b>
                    </div>
                    <div>
                      Incident Name :
                      <b>{{ incident.incidentName }} </b>
                    </div>
                    <div>
                      Description :
                      <b>{{
                        incident.incidentDescription | truncateCase : 45
                      }}</b>
                    </div>
                  </div>
                  <div class="card-action">
                    <button
                      [ngStyle]="
                        incident.incidentStatus == 3
                          ? { 'background-color': 'gray' }
                          : incident.incidentStatus == 0
                          ? { 'background-color': 'green' }
                          : incident.incidentStatus == 1
                          ? { 'background-color': 'red' }
                          : {}
                      "
                      mat-flat-button
                      (click)="onClickStatus(incident)"
                    >
                      Status:
                      {{
                        incident.incidentStatus == 1
                          ? "Closed"
                          : incident.incidentStatus == 0
                          ? "Open"
                          : incident.incidentStatus == 2
                          ? "Verified"
                          : incident.incidentStatus == 3
                          ? "Snoozed"
                          : incident.incidentStatus == 4
                          ? "In-Progress"
                          : incident.incidentStatus == 5
                          ? "On-Hold"
                          : incident.incidentStatus == 6
                          ? "Approved"
                          : incident.incidentStatus == 7
                          ? "Rejected"
                          : incident.incidentStatus == 8
                          ? "Completed"
                          : ("Not Specified" | titlecase)
                      }}
                    </button>
                    <button
                      mat-raised-button
                      (click)="onShowIncidentDetailDialog(incident)"
                    >
                      Go to details
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="2">
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h4 *ngIf="screenInfo === ScreenType.Desktop">Recent Requests</h4>
              <h5 *ngIf="screenInfo === ScreenType.Tablet">Recent Requests</h5>
            </div>
            <div
              *ngIf="recentRequests.length == 0"
              class="preview-content-empty"
            >
              No recent request
            </div>
            <div *ngIf="recentRequests.length > 0" class="preview-content">
              <section class="mobile-table-card-wrapper">
                <div
                  *ngFor="let complain of recentRequests"
                  class="mobile-table-card-container"
                >
                  <div class="card-content">
                    <div>
                      {{ getLabel(complain) }} Id :
                      <b>{{ complain.complainId.split("-")[0] }}</b>
                    </div>
                    <div>
                      {{ getLabel(complain) }} Date :
                      <b>{{
                        getFormatedDate(complain.complainAddDate)
                          | date : "dd/MM/yy, hh:mm:ss a'"
                      }}</b>
                    </div>
                    <div>
                      Subject :
                      <b>{{ complain.complainSubject }} </b>
                    </div>
                    <div>
                      Description :
                      <b>{{
                        complain.complainDescription | truncateCase : 45
                      }}</b>
                    </div>
                  </div>
                  <div class="card-action">
                    <button
                      [ngStyle]="
                        complain.complainIncidentDetails.incidentStatus == 3
                          ? { 'background-color': 'gray' }
                          : complain.complainIncidentDetails.incidentStatus == 0
                          ? { 'background-color': 'green' }
                          : complain.complainIncidentDetails.incidentStatus == 1
                          ? { 'background-color': 'red' }
                          : {}
                      "
                      mat-flat-button
                      (click)="onClickStatus(complain.complainIncidentDetails)"
                    >
                      Status:
                      {{
                        complain.complainIncidentDetails.incidentStatus == 1
                          ? "Closed"
                          : complain.complainIncidentDetails.incidentStatus == 0
                          ? "Open"
                          : complain.complainIncidentDetails.incidentStatus == 2
                          ? "Verified"
                          : complain.complainIncidentDetails.incidentStatus == 3
                          ? "Snoozed"
                          : complain.complainIncidentDetails.incidentStatus == 4
                          ? "In-Progress"
                          : complain.complainIncidentDetails.incidentStatus == 5
                          ? "On-Hold"
                          : complain.complainIncidentDetails.incidentStatus == 6
                          ? "Approved"
                          : complain.complainIncidentDetails.incidentStatus == 7
                          ? "Rejected"
                          : complain.complainIncidentDetails.incidentStatus == 8
                          ? "Completed"
                          : ("Not Specified" | titlecase)
                      }}
                    </button>
                    <button
                      mat-raised-button
                      (click)="
                        onShowIncidentDetailDialog(
                          complain.complainIncidentDetails
                        )
                      "
                    >
                      Go to details
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </section>
    <section class="user-dashboard-section" *ngIf="!isKiosk">
      <div class="user-dashboard-container">
        <mat-grid-list
          [cols]="
            screenInfo === ScreenType.Desktop && role == 'supervisor'
              ? 6
              : screenInfo === ScreenType.Desktop && role != 'supervisor'
              ? 8
              : screenInfo === ScreenType.Tablet
              ? 4
              : 2
          "
          [rowHeight]="
            screenInfo === ScreenType.Desktop ||
            screenInfo === ScreenType.Tablet
              ? '1:1'
              : '120px'
          "
          gutterSize="0px"
        >
          <mat-grid-tile
            *ngIf="screenInfo == ScreenType.Desktop && role == 'security'"
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              role != 'supervisor' &&
              role != 'security' &&
              role != 'housekeeping'
            "
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="scheduleVisitor()"
              >
                <img
                  src="assets/dashboard-icons/schedule.png"
                  alt="Rapid Schedule"
                />
                <div class="user-button-label">
                  {{ "Rapid Schedule" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile
            *ngIf="
              role == 'admin' ||
              role == 'user' ||
              role == 'security' ||
              role == 'supervisor'
            "
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="preVerifiedVisitor()"
                [ngStyle]="
                  isPreVerifiedVisitorSection
                  ? {
                    'background-color': 'rgb(254, 245, 249)',
                    }
                  : {}
              "
              >
                <img
                  src="assets/dashboard-icons/PreVerified.png"
                  alt="Pre Verified Visitor"
                />
                <div class="user-button-label">
                  {{ "Pre Verified Visitor" }}
                </div>
              </div>
            </div></mat-grid-tile
          >

          <mat-grid-tile *ngIf="role != 'security' && role != 'housekeeping'"
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="pendingapprovals(stepper)"
                [ngStyle]="
                  isShowPendingApprovalSection
                  ? {
                    'background-color': 'rgb(254, 245, 249)',
                    }
                  : {}"
              >
                <div class="mat-badge-div">
                  {{ pendingApproval }}
                </div>
                <img
                  src="assets/dashboard-icons/approved-people.png"
                  alt="Pending approvals"
                />
                <div class="user-button-label">
                  {{ "Pending Approvals" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile *ngIf="role != 'security' && role != 'housekeeping'"
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="preApprove()"
              >
                <img
                  src="assets/dashboard-icons/approval.png"
                  alt="Pre-Approve"
                />
                <div class="user-button-label">
                  {{ "Pre-Approve" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile
            *ngIf="
              role == 'admin' || role == 'security' || role == 'supervisor'
            "
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="AddGateEntry()"
                [ngStyle]="
                  isShowAddGateEntry
                  ? {
                    'background-color': 'rgb(254, 245, 249)',
                    }
                  : {}
              "
              >
                <img
                  src="assets/dashboard-icons/add_gate_entry.png"
                  alt="Add Gate Entry"
                />
                <div class="user-button-label">
                  {{ "Add Gate Entry" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile
            *ngIf="screenInfo == ScreenType.Desktop && role == 'housekeeping'"
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="screenInfo == ScreenType.Desktop && role == 'housekeeping'"
          ></mat-grid-tile>

          <mat-grid-tile *ngIf="role != 'security' && role != 'supervisor'"
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="securityCallback()"
              >
                <img
                  src="assets/dashboard-icons/security.png"
                  alt="Security Callback"
                />
                <div class="user-button-label">
                  {{ "Security Callback" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="createIncident()"
                [ngStyle]="
                  isShowCreateManulEvent
                  ? {
                    'background-color': 'rgb(254, 245, 249)',
                    }
                  : {}
              "
              >
                <img
                  src="assets/dashboard-icons/create_incident.png"
                  alt="Create Incident"
                />
                <div class="user-button-label">
                  {{ "Create Incident" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile
            *ngIf="
              role != 'security' &&
              role != 'housekeeping' &&
              role != 'supervisor'
            "
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                [ngStyle]="
                isShowCreatePollSection
                ? {
                  'background-color': 'rgb(254, 245, 249)',
                  }
                : {}
            "
                (click)="createPoll(stepper)"
              >
                <img
                  src="assets/dashboard-icons/polling.png"
                  alt="Create a poll"
                />
                <div class="user-button-label">
                  {{ "Create poll" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile
            *ngIf="screenInfo == ScreenType.Desktop && role == 'admin'"
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="screenInfo == ScreenType.Desktop && role == 'admin'"
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              role != 'supervisor' &&
              role != 'security' &&
              role != 'facility' &&
              role != 'housekeeping'
            "
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                [ngStyle]="
                isShowBulkInviteSection
                ? {
                  'background-color': 'rgb(254, 245, 249)',
                  }
                : {}
            "
                (click)="createEvent(stepper)"
              >
                <img
                  src="assets/dashboard-icons/invite-2.png"
                  alt="Create Event"
                />
                <div class="user-button-label">
                  {{ "Create Event" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile
            *ngIf="
              screenInfo == ScreenType.Desktop &&
              role !== 'security' &&
              role !== 'admin' &&
              role !== 'facility' &&
              role !== 'supervisor' &&
              role !== 'housekeeping'
            "
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="
              screenInfo == ScreenType.Desktop &&
              role !== 'admin' &&
              role !== 'security' &&
              role !== 'facility' &&
              role !== 'supervisor' &&
              role !== 'housekeeping'
            "
          ></mat-grid-tile>
          <mat-grid-tile
            *ngIf="screenInfo == ScreenType.Desktop && role == 'user'"
          ></mat-grid-tile>

          <!-- <mat-grid-tile
            *ngIf="
              role != 'supervisor' &&
              role != 'security' &&
              role != 'housekeeping'
            "
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                [ngStyle]="
                  isShowNoticeBoardSection
                  ? {
                    'background-color': 'rgb(254, 245, 249)',
                    }
                  : {}
              "
                mat-raised-button
                (click)="noticeBoard(stepper)"
              >
                <img
                  src="assets/dashboard-icons/notice.png"
                  alt="AumYe Community"
                />
                <div class="user-button-label">
                  {{ "AumYe Community" }}
                </div>
              </div>
            </div></mat-grid-tile
          > -->

          <mat-grid-tile *ngIf="role == 'admin'"
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                [ngStyle]="
                  isShowNoticeBoardSection
                  ? {
                    'background-color': 'rgb(254, 245, 249)',
                    }
                  : {}
              "
                mat-raised-button
                (click)="noticeBoard(stepper)"
              >
                <img
                  src="assets/dashboard-icons/comunity-1.png"
                  alt="Community Dashboard"
                />
                <div class="user-button-label">
                  {{ "Community Dashboard" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="lodgeComplaint()"
              >
                <img
                  src="assets/dashboard-icons/complaint.png"
                  alt="Lodge Request"
                />
                <div class="user-button-label">
                  {{ "Lodge Request" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile
            *ngIf="
              role == 'admin' || role == 'security' || role == 'supervisor'
            "
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="onClickScanQr()"
              >
                <img
                  src="assets/dashboard-icons/ScanQr.png"
                  alt="Scan QR/OTP"
                />
                <div class="user-button-label">
                  {{ "Scan QR/OTP" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
          <mat-grid-tile *ngIf="role != 'admin'"
            ><div
              [ngClass]="{
                'button-inside-tile':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile': screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="onClickSelfAttendance()"
              >
                <img
                  src="assets/dashboard-icons/immigration.png"
                  alt="Self Attendance"
                />
                <div class="user-button-label">
                  {{ "Self Attendance" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
        </mat-grid-list>
      </div>
    </section>
    <section class="user-dashboard-section" *ngIf="isKiosk">
      <div class="user-dashboard-container">
        <!-- <div class="user-dashboard-header">Aumye Kiosk</div> -->
        <mat-grid-list
          [cols]="
            screenInfo === ScreenType.Desktop
              ? 2
              : screenInfo === ScreenType.Tablet
              ? 2
              : 1
          "
          [rowHeight]="
            screenInfo === ScreenType.Desktop ||
            screenInfo === ScreenType.Tablet
              ? '1:1'
              : '260px'
          "
          gutterSize="0px"
        >
          <mat-grid-tile
            ><div
              [ngClass]="{
                'button-inside-tile-kiosk':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile-kiosk':
                  screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="AddGateEntry()"
                [ngStyle]="
                  isShowAddGateEntry
                  ? {
                    'background-color': 'rgb(254, 245, 249)',
                    }
                  : {}
              "
              >
                <img
                  src="assets/dashboard-icons/add_gate_entry.png"
                  alt="Add Gate Entry"
                />
                <div class="user-button-label">
                  {{ "Add Gate Entry" }}
                </div>
              </div>
            </div></mat-grid-tile
          >

          <mat-grid-tile
            ><div
              [ngClass]="{
                'button-inside-tile-kiosk':
                  screenInfo == ScreenType.Desktop ||
                  screenInfo == ScreenType.Tablet,

                'button-inside-tile-mobile-kiosk':
                  screenInfo == ScreenType.Mobile
              }"
            >
              <div
                mat-ripple
                class="dashboard-icons-div zoom-in hover-background"
                (click)="onClickScanQr()"
              >
                <img
                  src="assets/dashboard-icons/ScanQr.png"
                  alt="Scan QR/OTP"
                />
                <div class="user-button-label">
                  {{ "Scan QR/OTP" }}
                </div>
              </div>
            </div></mat-grid-tile
          >
        </mat-grid-list>
      </div>
    </section>
    <mat-divider></mat-divider>
    <section
      *ngIf="showPreviewSection && screenInfo === ScreenType.Mobile && !isKiosk"
      class="user-dashboard-preview-section"
    >
      <mat-grid-list cols="1" rowHeight="100px" gutterSize="10px">
        <mat-grid-tile rowspan="2">
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h6>Recent Incidents</h6>
            </div>
            <div
              *ngIf="recentIncidents.length == 0"
              class="preview-content-empty"
            >
              No recent incident
            </div>
            <div *ngIf="recentIncidents.length > 0" class="preview-content">
              <section class="mobile-table-card-wrapper">
                <div
                  *ngFor="let incident of recentIncidents"
                  class="mobile-table-card-container"
                >
                  <div class="card-content">
                    <div>
                      Incident Id :
                      <b> {{ incident.incidentId.split("-")[0] }}</b>
                    </div>
                    <div>
                      Date :
                      <b>{{
                        getFormatedDate(incident.eventCreateDate)
                          | date : "dd/MM/yy, hh:mm:ss a'"
                      }}</b>
                    </div>
                    <div>
                      Incident Name :
                      <b>{{ incident.incidentName }} </b>
                    </div>
                    <div>
                      Description :
                      <b>{{
                        incident.incidentDescription | truncateCase : 35
                      }}</b>
                    </div>
                  </div>
                  <div class="card-action">
                    <button
                      [ngStyle]="
                        incident.incidentStatus == 3
                          ? { 'background-color': 'gray' }
                          : incident.incidentStatus == 0
                          ? { 'background-color': 'green' }
                          : incident.incidentStatus == 1
                          ? { 'background-color': 'red' }
                          : {}
                      "
                      mat-raised-button
                      (click)="onClickStatus(incident)"
                    >
                      Status:
                      {{
                        incident.incidentStatus == 1
                          ? "Closed"
                          : incident.incidentStatus == 0
                          ? "Open"
                          : incident.incidentStatus == 2
                          ? "Verified"
                          : incident.incidentStatus == 3
                          ? "Snoozed"
                          : incident.incidentStatus == 4
                          ? "In-Progress"
                          : incident.incidentStatus == 5
                          ? "On-Hold"
                          : incident.incidentStatus == 6
                          ? "Approved"
                          : incident.incidentStatus == 7
                          ? "Rejected"
                          : incident.incidentStatus == 8
                          ? "Completed"
                          : ("Not Specified" | titlecase)
                      }}
                    </button>
                    <button
                      mat-raised-button
                      (click)="onShowIncidentDetailDialog(incident)"
                    >
                      Go to details
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="2">
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h6>Recent Requests</h6>
            </div>
            <div
              *ngIf="recentRequests.length == 0"
              class="preview-content-empty"
            >
              No recent request
            </div>
            <div *ngIf="recentRequests.length > 0" class="preview-content">
              <section class="mobile-table-card-wrapper">
                <div
                  *ngFor="let complain of recentRequests"
                  class="mobile-table-card-container"
                >
                  <div class="card-content">
                    <div>
                      {{ getLabel(complain) }} Id :
                      <b>{{ complain.complainId.split("-")[0] }}</b>
                    </div>
                    <div>
                      {{ getLabel(complain) }} Date :
                      <b>{{
                        getFormatedDate(complain.complainAddDate)
                          | date : "dd/MM/yy, hh:mm:ss a'"
                      }}</b>
                    </div>
                    <div>
                      Subject :
                      <b>{{ complain.complainSubject }} </b>
                    </div>
                    <div>
                      Description :
                      <b>{{
                        complain.complainDescription | truncateCase : 45
                      }}</b>
                    </div>
                  </div>
                  <div class="card-action">
                    <button
                      [ngStyle]="
                        complain.complainIncidentDetails.incidentStatus == 3
                          ? { 'background-color': 'gray' }
                          : complain.complainIncidentDetails.incidentStatus == 0
                          ? { 'background-color': 'green' }
                          : complain.complainIncidentDetails.incidentStatus == 1
                          ? { 'background-color': 'red' }
                          : {}
                      "
                      mat-raised-button
                      (click)="onClickStatus(complain.complainIncidentDetails)"
                    >
                      Status:
                      {{
                        complain.complainIncidentDetails.incidentStatus == 1
                          ? "Closed"
                          : complain.complainIncidentDetails.incidentStatus == 0
                          ? "Open"
                          : complain.complainIncidentDetails.incidentStatus == 2
                          ? "Verified"
                          : complain.complainIncidentDetails.incidentStatus == 3
                          ? "Snoozed"
                          : complain.complainIncidentDetails.incidentStatus == 4
                          ? "In-Progress"
                          : complain.complainIncidentDetails.incidentStatus == 5
                          ? "On-Hold"
                          : complain.complainIncidentDetails.incidentStatus == 6
                          ? "Approved"
                          : complain.complainIncidentDetails.incidentStatus == 7
                          ? "Rejected"
                          : complain.complainIncidentDetails.incidentStatus == 8
                          ? "Completed"
                          : ("Not Specified" | titlecase)
                      }}
                    </button>
                    <button
                      mat-raised-button
                      (click)="
                        onShowIncidentDetailDialog(
                          complain.complainIncidentDetails
                        )
                      "
                    >
                      Go to details
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </section>
    <section
      *ngIf="showPreviewSection && role != 'security' && !isKiosk"
      class="user-dashboard-preview-section"
    >
      <mat-grid-list
        [cols]="
          screenInfo === ScreenType.Desktop || screenInfo === ScreenType.Tablet
            ? '3'
            : '1'
        "
        rowHeight="100px"
        gutterSize="10px"
      >
        <mat-grid-tile
          rowspan="2"
          *ngIf="role != 'supervisor' && role != 'housekeeping'"
        >
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h5 *ngIf="screenInfo === ScreenType.Desktop">
                What’s Happening in Your Community
              </h5>
              <h6 *ngIf="screenInfo === ScreenType.Tablet">
                What’s Happening in Your Community
              </h6>
              <h6 *ngIf="screenInfo === ScreenType.Mobile">
                What’s Happening in Your Community
              </h6>
            </div>
            <div
              *ngIf="orgData.noticeBoardPosts?.length == 0"
              class="preview-content-empty"
            >
              No latest post
            </div>
            <div
              *ngIf="orgData.noticeBoardPosts?.length > 0"
              class="preview-content"
            >
              <div
                *ngFor="
                  let post of orgData.noticeBoardPosts.slice(0, 4);
                  let i = index
                "
                class="event-container"
              >
                <div class="event-header">
                  <div>
                    {{
                      post.postDescription
                        | truncateCase
                          : (screenInfo === ScreenType.Mobile ? 20 : 30)
                    }}
                    <h6 *ngIf="i <= 2">
                      <i>-{{ post.postUsername }}</i>
                      <span class="post-time">{{
                        getFormatedDateTime(post.postAddDate)
                      }}</span>
                    </h6>
                  </div>
                  <!-- (click)="scrollToPost(i)" -->
                  <button
                    (click)="goToPost(post.postId)"
                    mat-icon-button
                    matTooltip="See on Board"
                  >
                    <mat-icon>directions</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="orgData.userEvents?.length > 0" rowspan="2">
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h4 *ngIf="screenInfo === ScreenType.Desktop">Upcoming Events</h4>
              <h5 *ngIf="screenInfo === ScreenType.Tablet">Upcoming Events</h5>
              <h6 *ngIf="screenInfo === ScreenType.Mobile">Upcoming Events</h6>
            </div>
            <div
              *ngIf="orgData.userEvents?.length == 0"
              class="preview-content-empty"
            >
              No upcoming events
            </div>
            <div *ngIf="orgData.userEvents?.length > 0" class="preview-content">
              <div
                *ngFor="let event of orgData.userEvents"
                class="event-container"
              >
                <div class="event-header">
                  {{ event.eventTitle }}
                  <button mat-icon-button (click)="openEventDialog(event)">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="getLiveAndPendingUserPolls().length > 0"
          rowspan="2"
        >
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h4 *ngIf="screenInfo === ScreenType.Desktop">Live polls</h4>
              <h5 *ngIf="screenInfo === ScreenType.Tablet">Live polls</h5>
              <h6 *ngIf="screenInfo === ScreenType.Mobile">Live polls</h6>
            </div>
            <div
              *ngIf="orgData.userPolls?.length == 0"
              class="preview-content-empty"
            >
              No live polls
            </div>
            <div
              *ngIf="getLiveAndPendingUserPolls().length > 0"
              class="preview-content"
            >
              <div
                *ngFor="let poll of getLiveAndPendingUserPolls()"
                class="event-container"
              >
                <div class="event-header">
                  {{
                    poll.pollTitle
                      | truncateCase
                        : (screenInfo === ScreenType.Mobile ? 20 : 30)
                  }}
                  <div>
                    <div>
                      <button
                        [disabled]="false"
                        [ngStyle]="{
                          opacity: false ? '0.5' : '1',
                          cursor: false ? 'not-allowed' : 'pointer'
                        }"
                        mat-icon-button
                        [matTooltip]="
                          screenInfo == ScreenType.Mobile
                            ? ''
                            : 'Share the poll'
                        "
                        (click)="shareUserPoll(poll)"
                      >
                        <mat-icon>share</mat-icon></button
                      ><button
                        mat-icon-button
                        (click)="openUserPollDialog(poll)"
                      >
                        <mat-icon>more_vert</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="getExpiredUserPolls().length > 0 && role != 'supervisor'"
          rowspan="2"
        >
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h4 *ngIf="screenInfo === ScreenType.Desktop">
                Results from previous Poll
              </h4>
              <h5 *ngIf="screenInfo === ScreenType.Tablet">
                Results from previous Poll
              </h5>

              <h6 *ngIf="screenInfo === ScreenType.Mobile">
                Results from previous Poll
              </h6>
            </div>
            <div
              *ngIf="orgData.userPolls?.length == 0"
              class="preview-content-empty"
            >
              No Expired polls
            </div>
            <div
              *ngIf="getExpiredUserPolls().length > 0"
              class="preview-content"
            >
              <div
                *ngFor="let poll of getExpiredUserPolls()"
                class="event-container"
              >
                <div class="event-header">
                  <div>
                    {{
                      poll.pollTitle
                        | truncateCase
                          : (screenInfo === ScreenType.Mobile ? 20 : 30)
                    }}
                    <h6>
                      <i>Engagement: </i>
                      <span
                        class="post-time"
                        style="font-size: 10px; margin-left: 10px"
                      >
                        <b>{{
                          poll.pollResponse === null
                            ? "0%"
                            : calculateEngagement(poll)
                        }}</b>
                      </span>
                    </h6>
                  </div>
                  <div>
                    <div style="display: flex">
                      <div class="event-poll-response" *ngIf="false">
                        {{ checkIsPollLiveAndResponded(poll) ? "" : "" }}
                      </div>
                      <button
                        *ngIf="!checkIsPollLiveAndResponded(poll) || true"
                        (click)="onViewPollResult(poll)"
                        mat-icon-button
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile rowspan="2">
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h4 *ngIf="screenInfo === ScreenType.Desktop">
                Pre approved visitors
              </h4>
              <h5 *ngIf="screenInfo === ScreenType.Tablet">
                Pre approved visitors
              </h5>

              <h6 *ngIf="screenInfo === ScreenType.Mobile">
                Pre approved visitors
              </h6>
            </div>
            <div
              *ngIf="preApprovedVisitor?.length == 0"
              class="preview-content-empty"
            >
              No pre approvals
            </div>
            <div *ngIf="preApprovedVisitor?.length > 0" class="preview-content">
              <div
                *ngFor="let visitor of preApprovedVisitor"
                class="event-container"
                [ngStyle]="
                  checkIsCheckedIn(visitor)
                    ? {
                        'background-color': 'green',
                        color: 'white',
                        'margin-top': '10px'
                      }
                    : checkIsCheckedOOut(visitor)
                    ? {
                        'background-color': 'gray',
                        color: 'white',
                        'margin-top': '10px'
                      }
                    : {}
                "
              >
                <div class="event-header">
                  <div>
                    {{ visitor.firstName }}
                    <h6
                      *ngIf="
                        visitor.visitorType == '1' ||
                        visitor.isPreApproved == 'true'
                      "
                    >
                      <i>Vendor: </i>
                      <span
                        class="post-time"
                        style="
                          font-size: 10px;
                          margin-left: 10px;
                          letter-spacing: 3px;
                        "
                      >
                        <b>{{ visitor.visitorCategory }}</b>
                      </span>
                    </h6>
                  </div>
                  <button
                    mat-icon-button
                    (click)="openPreApprovedVisitorDialog(visitor)"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="!isShowIncidentDetail && role != 'housekeeping'"
          [colspan]="screenInfo != ScreenType.Mobile ? 3 : 1"
          [rowspan]="
            (screenInfo === ScreenType.Desktop ||
              screenInfo === ScreenType.Tablet) &&
            isShowVisitorDetail
              ? '9'
              : screenInfo === ScreenType.Mobile && isShowVisitorDetail
              ? '8'
              : '4'
          "
        >
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h4 *ngIf="screenInfo === ScreenType.Desktop">
                Expected Visitors
              </h4>
              <h5 *ngIf="screenInfo === ScreenType.Tablet">
                Expected Visitors
              </h5>

              <h6 *ngIf="screenInfo === ScreenType.Mobile">
                Expected Visitors
              </h6>
            </div>
            <div *ngIf="temp?.length == 0" class="preview-content-empty">
              No expected visitors
            </div>

            <div
              class="preview-content-security-custom"
              *ngIf="temp?.length != 0"
            >
              <div style="display: flex; justify-content: flex-end">
                <div style="display: flex; align-items: center">
                  <mat-button-toggle-group
                    [(ngModel)]="selectedOption"
                    (change)="onSelectionChange($event)"
                  >
                    <mat-button-toggle value="all">All</mat-button-toggle>
                    <mat-button-toggle value="my"
                      >My Visitors</mat-button-toggle
                    >
                  </mat-button-toggle-group>
                </div>
                <mat-form-field
                  style="width: 250px"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Search</mat-label>
                  <input matInput (keyup)="applyFilter($event)" #input />
                  <mat-icon matPrefix>search</mat-icon>
                </mat-form-field>
              </div>
              <div
                class="table-container"
                *ngIf="screenInfo != ScreenType.Mobile"
              >
                <table
                  mat-table
                  [dataSource]="
                    selectedOption === 'all'
                      ? expectedVisitors
                      : myExpectedVisitors
                  "
                >
                  <ng-container matColumnDef="visname">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Visitor Name
                    </th>
                    <td
                      style="border-right: 1px solid"
                      mat-cell
                      *matCellDef="let row"
                    >
                      {{ row.firstName + " " + row.lastName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="hostname">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Host Name
                    </th>
                    <td
                      style="border-right: 1px solid"
                      mat-cell
                      *matCellDef="let row"
                    >
                      <p
                        *ngIf="
                          row.securityStatus != 4 && row.securityStatus != 5
                        "
                        style="margin: 0"
                      >
                        {{ row.hostName }}
                      </p>
                      <button
                        *ngIf="
                          row.securityStatus == 4 || row.securityStatus == 5
                        "
                        mat-raised-button
                        [ngStyle]="
                          row.securityStatus == 4
                            ? {
                                'background-color': 'green',
                                color: 'white',
                                'font-size': '16px',
                                'font-weight': 'bold'
                              }
                            : row.securityStatus == 5
                            ? {
                                'background-color': 'gray',
                                color: 'white',
                                'font-size': '16px',
                                'font-weight': 'bold'
                              }
                            : {}
                        "
                      >
                        {{ row.hostName }}
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="date">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Visit Date
                    </th>
                    <td
                      style="border-right: 1px solid"
                      mat-cell
                      *matCellDef="let row"
                    >
                      {{
                        getFormatedDate(row.visitDateTime)
                          | date : "E, MMMM d, y"
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Details">
                    <th
                      style="text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                      aria-label="row actions"
                    >
                      Details
                    </th>
                    <td
                      style="text-align: center"
                      mat-cell
                      *matCellDef="let element"
                    >
                      <button
                        (click)="onShowVisitorDetailDialog(element)"
                        mat-mini-fab
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="security">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Status
                    </th>
                    <td
                      style="border-right: 1px solid; text-align: center"
                      mat-cell
                      *matCellDef="let row"
                    >
                      <button
                        [ngStyle]="
                          row.securityStatus == 1 ||
                          row.securityStatus == 4 ||
                          row.securityStatus == 5
                            ? { 'background-color': 'green' }
                            : row.securityStatus == -1 ||
                              row.securityStatus == 3
                            ? { 'background-color': '#FFBF00' }
                            : { 'background-color': 'red' }
                        "
                        class="security-button"
                        mat-raised-button
                      >
                        {{
                          row.securityStatus == -1
                            ? "Rejected"
                            : row.securityStatus == 1 && row.isGateEntry == "1"
                            ? "Approved"
                            : row.securityStatus == 1 && row.isGateEntry == "0"
                            ? "Verified"
                            : row.securityStatus == 3
                            ? "Auto Rejected"
                            : row.securityStatus == 0 &&
                              row.isPreApproved == "true"
                            ? "Pre-Approved"
                            : row.visitorType == "3"
                            ? "Pre-Verified"
                            : row.securityStatus == 4
                            ? "In Progress"
                            : row.securityStatus == 5
                            ? "Completed"
                            : "Pending"
                        }}
                      </button>
                      <button
                        *ngIf="row.checkIn && row.inProgressStatusTime"
                        [ngStyle]="
                          row.completeStatusTime == null
                            ? { 'background-color': '#ffbf00' }
                            : { 'background-color': 'gray' }
                        "
                        style="
                          color: white;
                          font-size: 18px;
                          padding: 0 5px;
                          margin-left: 10px;
                        "
                        mat-flat-button
                      >
                        {{ row.timerValue }}
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="time">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Visit Time
                    </th>
                    <td
                      style="border-right: 1px solid; text-align: center"
                      mat-cell
                      *matCellDef="let row"
                    >
                      <ng-container
                        *ngIf="row.isPreApproved == 'true'; else dateTime"
                      >
                        <button
                          class="security-button"
                          [ngStyle]="
                            row.checkIn == null
                              ? {
                                  'background-color': 'lightskyblue',
                                  color: 'black'
                                }
                              : row.checkIn &&
                                row.checkOut == null &&
                                (getExpectedCheckoutTimeNumber(row) | async) >
                                  15
                              ? { 'background-color': 'green', color: 'white' }
                              : row.checkIn &&
                                row.checkOut == null &&
                                (getExpectedCheckoutTimeNumber(row) | async) <=
                                  15 &&
                                (getExpectedCheckoutTimeNumber(row) | async) >=
                                  2
                              ? { 'background-color': 'orange', color: 'white' }
                              : row.checkIn &&
                                row.checkOut == null &&
                                (getExpectedCheckoutTimeNumber(row) | async) < 2
                              ? { 'background-color': 'red', color: 'white' }
                              : { 'background-color': 'darkgray' }
                          "
                          mat-raised-button
                        >
                          {{
                            row.checkIn == null
                              ? "Not yet arrived"
                              : row.checkIn &&
                                row.checkOut == null &&
                                (getExpectedCheckoutTimeNumber(row) | async) > 0
                              ? (getExpectedCheckoutTime(row) | async)
                              : row.checkIn &&
                                row.checkOut == null &&
                                (getExpectedCheckoutTimeNumber(row) | async) ==
                                  0
                              ? "Time Expired"
                              : row.checkOut != null
                              ? "Visited"
                              : ""
                          }}
                        </button>
                      </ng-container>
                      <ng-template #dateTime>
                        {{
                          getFormatedDate(row.visitDateTime) | date : "hh:mm a"
                        }}
                      </ng-template>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="details">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                      aria-label="row actions"
                    ></th>
                    <td
                      style="border-right: 1px solid; text-align: center"
                      mat-cell
                      *matCellDef="let element"
                    ></td>
                  </ng-container>
                  <tr
                    class="table-header"
                    mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                </table>
              </div>
              <div
                class="mobile-cards-container"
                *ngIf="screenInfo == ScreenType.Mobile"
              >
                <app-mobile-table-card
                  [visitorTableData]="
                    selectedOption === 'all'
                      ? expectedVisitors
                      : myExpectedVisitors
                  "
                  [isSecurity]="true"
                  [isShowAction]="false"
                  [tableType]="'visitor'"
                  (showDetails)="onShowVisitorDetailDialog($event)"
                  (showPreApprovedAction)="onActionPreApproved($event)"
                ></app-mobile-table-card>
                <!-- <mat-card
                  class="visitor-card"
                  *ngFor="
                    let row of selectedOption === 'all'
                      ? expectedVisitors
                      : myExpectedVisitors
                  "
                >
                  <!-- Visitor Name & Host Name Section --
                  <mat-card-header>
                    <mat-card-title>{{
                      row.firstName + " " + row.lastName
                    }}</mat-card-title>
                    <!-- <mat-card-subtitle>
                      <ng-container
                        *ngIf="
                          row.securityStatus != 4 && row.securityStatus != 5
                        "
                      >
                        Host: {{ row.hostName }}
                      </ng-container>
                      <button
                        *ngIf="
                          row.securityStatus == 4 || row.securityStatus == 5
                        "
                        mat-raised-button
                        [ngStyle]="
                          row.securityStatus == 4
                            ? {
                                'background-color': 'green',
                                color: 'white',
                                'font-size': '14px',
                                'font-weight': 'bold'
                              }
                            : row.securityStatus == 5
                            ? {
                                'background-color': 'gray',
                                color: 'white',
                                'font-size': '14px',
                                'font-weight': 'bold'
                              }
                            : {}
                        "
                      >
                        Host: {{ row.hostName }}
                      </button>
                    </mat-card-subtitle> --
                  </mat-card-header>

                  <mat-card-content>
                    <!-- Visit Date & Time --
                    <div class="card-detail-row">
                      <div class="label">Host Name:</div>
                      <div class="value">
                        <ng-container
                          *ngIf="
                            row.securityStatus != 4 && row.securityStatus != 5
                          "
                        >
                          {{ row.hostName }}
                        </ng-container>
                        <button
                          *ngIf="
                            row.securityStatus == 4 || row.securityStatus == 5
                          "
                          mat-raised-button
                          [ngStyle]="
                            row.securityStatus == 4
                              ? {
                                  'background-color': 'green',
                                  color: 'white',
                                  'font-size': '14px',
                                  'font-weight': 'bold'
                                }
                              : row.securityStatus == 5
                              ? {
                                  'background-color': 'gray',
                                  color: 'white',
                                  'font-size': '14px',
                                  'font-weight': 'bold'
                                }
                              : {}
                          "
                        >
                          {{ row.hostName }}
                        </button>
                      </div>
                    </div>

                    <div class="card-detail-row">
                      <div class="label">Visit Time:</div>
                      <div class="value">
                        <ng-container
                          *ngIf="
                            row.isPreApproved == 'true';
                            else dateTimeValue
                          "
                        >
                          <button
                            class="security-button"
                            [ngStyle]="
                              row.checkIn == null
                                ? {
                                    'background-color': 'lightskyblue',
                                    color: 'black'
                                  }
                                : row.checkIn &&
                                  row.checkOut == null &&
                                  (getExpectedCheckoutTimeNumber(row) | async) >
                                    15
                                ? {
                                    'background-color': 'green',
                                    color: 'white'
                                  }
                                : row.checkIn &&
                                  row.checkOut == null &&
                                  (getExpectedCheckoutTimeNumber(row)
                                    | async) <= 15 &&
                                  (getExpectedCheckoutTimeNumber(row)
                                    | async) >= 2
                                ? {
                                    'background-color': 'orange',
                                    color: 'white'
                                  }
                                : row.checkIn &&
                                  row.checkOut == null &&
                                  (getExpectedCheckoutTimeNumber(row) | async) <
                                    2
                                ? {
                                    'background-color': 'red',
                                    color: 'white'
                                  }
                                : {
                                    'background-color': 'darkgray'
                                  }
                            "
                            mat-raised-button
                          >
                            {{
                              row.checkIn == null
                                ? "Not yet arrived"
                                : row.checkIn &&
                                  row.checkOut == null &&
                                  (getExpectedCheckoutTimeNumber(row) | async) >
                                    0
                                ? (getExpectedCheckoutTime(row) | async)
                                : row.checkIn &&
                                  row.checkOut == null &&
                                  (getExpectedCheckoutTimeNumber(row)
                                    | async) == 0
                                ? "Time Expired"
                                : row.checkOut != null
                                ? "Visited"
                                : ""
                            }}
                          </button>
                        </ng-container>
                        <ng-template #dateTimeValue>
                          {{
                            getFormatedDate(row.visitDateTime)
                              | date : "hh:mm a"
                          }}
                        </ng-template>
                      </div>
                    </div>

                    <!-- Status --
                    <div class="card-detail-row">
                      <div class="label">Status:</div>
                      <div class="value status-container">
                        <button
                          [ngStyle]="
                            row.securityStatus == 1 ||
                            row.securityStatus == 4 ||
                            row.securityStatus == 5
                              ? { 'background-color': 'green' }
                              : row.securityStatus == -1 ||
                                row.securityStatus == 3
                              ? { 'background-color': '#FFBF00' }
                              : { 'background-color': 'red' }
                          "
                          class="security-button"
                          mat-raised-button
                        >
                          {{
                            row.securityStatus == -1
                              ? "Rejected"
                              : row.securityStatus == 1 &&
                                row.isGateEntry == "1"
                              ? "Approved"
                              : row.securityStatus == 1 &&
                                row.isGateEntry == "0"
                              ? "Verified"
                              : row.securityStatus == 3
                              ? "Auto Rejected"
                              : row.securityStatus == 0 &&
                                row.isPreApproved == "true"
                              ? "Pre-Approved"
                              : row.visitorType == "3"
                              ? "Pre-Verified"
                              : row.securityStatus == 4
                              ? "In Progress"
                              : row.securityStatus == 5
                              ? "Completed"
                              : "Pending"
                          }}
                        </button>

                        <button
                          *ngIf="row.checkIn && row.inProgressStatusTime"
                          [ngStyle]="
                            row.completeStatusTime == null
                              ? { 'background-color': '#ffbf00' }
                              : { 'background-color': 'gray' }
                          "
                          style="
                            color: white;
                            font-size: 16px;
                            padding: 0 5px;
                            margin-left: 5px;
                          "
                          mat-flat-button
                        >
                          {{ row.timerValue }}
                        </button>
                      </div>
                    </div>
                  </mat-card-content>

                  <mat-card-actions align="end">
                    <button mat-button (click)="onShowVisitorDetailDialog(row)">
                      <mat-icon>open_in_new</mat-icon> DETAILS
                    </button>
                  </mat-card-actions>
                </mat-card> -->
              </div>
            </div>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </section>
    <section
      *ngIf="
        isShowPendingApprovalSection ||
        isShowCreateManulEvent ||
        isShowAddGateEntry ||
        isShowBulkInviteSection ||
        isShowCreatePollSection ||
        isPreVerifiedVisitorSection ||
        isShowNoticeBoardSection
      "
    >
      <mat-divider></mat-divider>
      <br />
      <div
        *ngIf="isShowPendingApprovalSection && screenInfo != ScreenType.Mobile"
        class="user-dashboard-pending-approval-section"
      >
        <app-pending-host-approvals
          [pendingVisitorData]="orgData.visitorDetails.visitorList"
          [screen]="screenInfo"
          (onClosePendingVisitorSection)="closeSection()"
        ></app-pending-host-approvals>
      </div>
      <div
        *ngIf="isShowCreateManulEvent && screenInfo != ScreenType.Mobile"
        class="user-dashboard-create-event-section"
      >
        <div class="user-dashboard-close-button">
          <button mat-mini-fab (click)="closeSection()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
        <div *ngIf="isLoaded">
          <app-incident-dashboard
            [dashboardData]="orgData"
            [isNotRegularFlow]="true"
          >
          </app-incident-dashboard>
        </div>
      </div>
      <div
        *ngIf="isShowAddGateEntry && screenInfo != ScreenType.Mobile"
        class="user-dashboard-create-event-section"
      >
        <div
          class="user-dashboard-gate-entry-close-button"
          [ngStyle]="
            isShowClusterButton
              ? { 'justify-content': 'space-between' }
              : { 'justify-content': 'flex-end' }
          "
        >
          <button
            *ngIf="isShowClusterButton"
            (click)="openPreApprovedCluster()"
            mat-raised-button
          >
            Combine PreApproved
          </button>
          <button
            style="width: 35px; height: 35px"
            mat-mini-fab
            (click)="closeSection()"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </div>
        <div *ngIf="isLoaded">
          <app-visitor-dashboard
            [dashboardData]="orgData"
            [isNotRegularFlow]="true"
          ></app-visitor-dashboard>
        </div>
      </div>
      <div
        *ngIf="isShowBulkInviteSection && screenInfo != ScreenType.Mobile"
        class="user-dashboard-create-event-section"
      >
        <div class="user-dashboard-close-button">
          <button mat-mini-fab (click)="closeSection()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
        <app-bulk-invite
          [userEvents]="orgData.userEvents"
          [screen]="screenInfo"
          (onSendBulkInvitation)="sendBulkInvitation($event)"
        ></app-bulk-invite>
      </div>
      <div
        *ngIf="isShowCreatePollSection && screenInfo != ScreenType.Mobile"
        class="user-dashboard-create-event-section"
      >
        <div class="user-dashboard-close-button">
          <button mat-mini-fab (click)="closeSection()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
        <app-user-create-poll
          [userList]="orgData.orgUserList"
          (onCreateUserPoll)="createUserPoll($event)"
        ></app-user-create-poll>
      </div>
      <div
        *ngIf="isPreVerifiedVisitorSection && screenInfo != ScreenType.Mobile"
        class="user-dashboard-create-event-section"
      >
        <div class="user-dashboard-close-button">
          <button mat-mini-fab (click)="closeSection()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
        <app-visitor-calendar-container></app-visitor-calendar-container>
      </div>
      <div
        *ngIf="isShowNoticeBoardSection && screenInfo != ScreenType.Mobile"
        class="user-dashboard-create-event-section"
      >
        <div class="user-dashboard-close-button">
          <button mat-mini-fab (click)="closeSection()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
        <div class="post-reports-section">
          <app-post-reports
            (postActionTaken)="onPostActionTaken($event)"
            (postFlaggedpostAction)="onPostFlaggedpostAction($event)"
            [orgPosts]="orgData.noticeBoardPosts"
            [users]="orgData.orgUserList"
            [screenInfo]="screenInfo"
            [loggedIsUsernameProfile]="loggedIsUsernameProfile"
            [currentUserId]="userId"
          >
          </app-post-reports>
        </div>
        <!-- <app-user-notice-board
          [parentSelectedPostIndex]="selectedPostIndex"
          (onCreateUserPost)="createUserPost($event)"
          (onRefreshUserPost)="refreshUserPost()"
          (onPostComment)="postUserComment($event)"
          (onOpenSharedPostPollData)="openUserPollDialog($event)"
          (onPostLike)="postUserLike($event)"
          (onReportPost)="saveUserReportPost($event)"
          [onShareUserPollData]="pollData"
        ></app-user-notice-board> -->
      </div>
    </section>
    <section *ngIf="role == 'security' && showPreviewSection && !isKiosk">
      <mat-grid-list
        [cols]="
          screenInfo === ScreenType.Desktop || screenInfo === ScreenType.Tablet
            ? '2'
            : '1'
        "
        rowHeight="100px"
        gutterSize="10px"
      >
        <mat-grid-tile
          *ngIf="!isShowVisitorDetail && !isShowCriticalIncidents"
          [colspan]="
            isShowUrgentIncidents && screenInfo != ScreenType.Mobile ? 2 : 1
          "
          [rowspan]="
            (screenInfo === ScreenType.Desktop ||
              screenInfo === ScreenType.Tablet) &&
            isShowUrgentIncidents
              ? '7'
              : screenInfo === ScreenType.Mobile && isShowUrgentIncidents
              ? '8'
              : '2'
          "
        >
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h4>Urgent action/calls</h4>
            </div>
            <div
              *ngIf="securityCallbackIncidents?.length == 0 && false"
              class="preview-content-empty"
            >
              No Urgent action/calls
            </div>
            <div class="preview-content-security">
              <app-incident-security-callback
                *ngIf="!isShowUrgentIncidents"
                [isShowHeader]="false"
                [incidentTableData]="securityCallbackIncidents"
                [isIncidentDetailsClosed]="isShowUrgentIncidents"
                (showIncidentDetail)="onShowUrgentIncidentDetail($event)"
                (verifyIncident)="onVerifyIncident($event)"
              ></app-incident-security-callback>
              <app-incident-detail
                *ngIf="isShowUrgentIncidents"
                [incidentDetails]="incidentDetails"
                (closeIncidentDetail)="onCloseIncidentDetail()"
                (snoozeIncident)="onSnoozeIncident($event)"
                (showTimeline)="onShowTimeline($event)"
                [orgUser]="orgData.orgUserList"
                [OrgAssets]="orgData.orgAssetList.assets"
              ></app-incident-detail>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="!isShowVisitorDetail && !isShowUrgentIncidents"
          [colspan]="
            isShowCriticalIncidents && screenInfo != ScreenType.Mobile ? 2 : 1
          "
          [rowspan]="
            (screenInfo === ScreenType.Desktop ||
              screenInfo === ScreenType.Tablet) &&
            isShowCriticalIncidents
              ? '7'
              : screenInfo === ScreenType.Mobile && isShowCriticalIncidents
              ? '8'
              : '2'
          "
        >
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h4>Critical Incidents</h4>
            </div>
            <div
              *ngIf="criticalIncidents?.length == 0"
              class="preview-content-empty"
            >
              No Critical Incidents
            </div>
            <div
              class="preview-content-security"
              *ngIf="criticalIncidents.length > 0"
            >
              <app-incident-security-callback
                *ngIf="!isShowCriticalIncidents"
                [isShowHeader]="false"
                [incidentTableData]="criticalIncidents"
                [isIncidentDetailsClosed]="isShowCriticalIncidents"
                (showIncidentDetail)="onShowCriticalIncidentDetail($event)"
                (verifyIncident)="onVerifyIncident($event)"
                (snoozeIncident)="onSnoozeIncident($event)"
              ></app-incident-security-callback>
              <app-incident-detail
                *ngIf="isShowCriticalIncidents"
                [incidentDetails]="incidentDetails"
                (closeIncidentDetail)="onCloseIncidentDetail()"
                (snoozeIncident)="onSnoozeIncident($event)"
                (showTimeline)="onShowTimeline($event)"
                [orgUser]="orgData.orgUserList"
                [OrgAssets]="orgData.orgAssetList.assets"
              ></app-incident-detail>
            </div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="!isShowIncidentDetail"
          [colspan]="screenInfo != ScreenType.Mobile ? 2 : 1"
          [rowspan]="
            (screenInfo === ScreenType.Desktop ||
              screenInfo === ScreenType.Tablet) &&
            isShowVisitorDetail
              ? '9'
              : screenInfo === ScreenType.Mobile && isShowVisitorDetail
              ? '8'
              : '4'
          "
        >
          <div class="user-dashboard-preview-container">
            <div class="preview-header">
              <h4 *ngIf="screenInfo === ScreenType.Desktop">
                Expected Visitors
              </h4>
              <h5 *ngIf="screenInfo === ScreenType.Tablet">
                Expected Visitors
              </h5>

              <h6 *ngIf="screenInfo === ScreenType.Mobile">
                Expected Visitors
              </h6>
            </div>
            <div *ngIf="temp?.length == 0" class="preview-content-empty">
              No expected visitors
            </div>

            <div
              class="preview-content-security-custom"
              *ngIf="temp?.length != 0"
            >
              <div style="display: flex; justify-content: flex-end">
                <mat-form-field
                  style="width: 250px"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Search</mat-label>
                  <input matInput (keyup)="applyFilter($event)" #input />
                  <mat-icon matPrefix>search</mat-icon>
                </mat-form-field>
              </div>
              <div class="table-container">
                <table mat-table [dataSource]="expectedVisitors">
                  <ng-container matColumnDef="visname">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Visitor Name
                    </th>
                    <td
                      style="border-right: 1px solid"
                      mat-cell
                      *matCellDef="let row"
                    >
                      {{ row.firstName + " " + row.lastName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="hostname">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Host Name
                    </th>
                    <td
                      style="border-right: 1px solid"
                      mat-cell
                      *matCellDef="let row"
                    >
                      <p
                        *ngIf="
                          row.securityStatus != 4 && row.securityStatus != 5
                        "
                        style="margin: 0"
                      >
                        {{ row.hostName }}
                      </p>
                      <button
                        *ngIf="
                          row.securityStatus == 4 || row.securityStatus == 5
                        "
                        mat-raised-button
                        [ngStyle]="
                          row.securityStatus == 4
                            ? {
                                'background-color': 'green',
                                color: 'white',
                                'font-size': '16px',
                                'font-weight': 'bold'
                              }
                            : row.securityStatus == 5
                            ? {
                                'background-color': 'gray',
                                color: 'white',
                                'font-size': '16px',
                                'font-weight': 'bold'
                              }
                            : {}
                        "
                      >
                        {{ row.hostName }}
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="date">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Visit Date
                    </th>
                    <td
                      style="border-right: 1px solid"
                      mat-cell
                      *matCellDef="let row"
                    >
                      {{
                        getFormatedDate(row.visitDateTime)
                          | date : "E, MMMM d, y"
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Details">
                    <th
                      style="text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                      aria-label="row actions"
                    >
                      Details
                    </th>
                    <td
                      style="text-align: center"
                      mat-cell
                      *matCellDef="let element"
                    >
                      <button
                        (click)="onShowVisitorDetailDialog(element)"
                        mat-mini-fab
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="security">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Status
                    </th>
                    <td
                      style="border-right: 1px solid; text-align: center"
                      mat-cell
                      *matCellDef="let row"
                    >
                      <button
                        [ngStyle]="
                          row.securityStatus == 1 ||
                          row.securityStatus == 4 ||
                          row.securityStatus == 5
                            ? { 'background-color': 'green' }
                            : row.securityStatus == -1 ||
                              row.securityStatus == 3
                            ? { 'background-color': '#FFBF00' }
                            : { 'background-color': 'red' }
                        "
                        class="security-button"
                        mat-raised-button
                      >
                        {{
                          row.securityStatus == -1
                            ? "Rejected"
                            : row.securityStatus == 1 && row.isGateEntry == "1"
                            ? "Approved"
                            : row.securityStatus == 1 && row.isGateEntry == "0"
                            ? "Verified"
                            : row.securityStatus == 3
                            ? "Auto Rejected"
                            : row.securityStatus == 0 &&
                              row.isPreApproved == "true"
                            ? "Pre-Approved"
                            : row.visitorType == "3"
                            ? "Pre-Verified"
                            : row.securityStatus == 4
                            ? "In Progress"
                            : row.securityStatus == 5
                            ? "Completed"
                            : "Pending"
                        }}
                      </button>
                      <button
                        *ngIf="row.checkIn && row.inProgressStatusTime"
                        [ngStyle]="
                          row.completeStatusTime == null
                            ? { 'background-color': '#ffbf00' }
                            : { 'background-color': 'gray' }
                        "
                        style="
                          color: white;
                          font-size: 18px;
                          padding: 0 5px;
                          margin-left: 10px;
                        "
                        mat-flat-button
                      >
                        {{ row.timerValue }}
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="time">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                    >
                      Visit Time
                    </th>
                    <td
                      style="border-right: 1px solid; text-align: center"
                      mat-cell
                      *matCellDef="let row"
                    >
                      <ng-container
                        *ngIf="row.isPreApproved == 'true'; else dateTime"
                      >
                        <button
                          class="security-button"
                          [ngStyle]="
                            row.checkIn == null
                              ? {
                                  'background-color': 'lightskyblue',
                                  color: 'black'
                                }
                              : row.checkIn &&
                                row.checkOut == null &&
                                (getExpectedCheckoutTimeNumber(row) | async) >
                                  15
                              ? { 'background-color': 'green', color: 'white' }
                              : row.checkIn &&
                                row.checkOut == null &&
                                (getExpectedCheckoutTimeNumber(row) | async) <=
                                  15 &&
                                (getExpectedCheckoutTimeNumber(row) | async) >=
                                  2
                              ? { 'background-color': 'orange', color: 'white' }
                              : row.checkIn &&
                                row.checkOut == null &&
                                (getExpectedCheckoutTimeNumber(row) | async) < 2
                              ? { 'background-color': 'red', color: 'white' }
                              : { 'background-color': 'darkgray' }
                          "
                          mat-raised-button
                        >
                          {{
                            row.checkIn == null
                              ? "Not yet arrived"
                              : row.checkIn &&
                                row.checkOut == null &&
                                (getExpectedCheckoutTimeNumber(row) | async) > 0
                              ? (getExpectedCheckoutTime(row) | async)
                              : row.checkIn &&
                                row.checkOut == null &&
                                (getExpectedCheckoutTimeNumber(row) | async) ==
                                  0
                              ? "Time Expired"
                              : row.checkOut != null
                              ? "Visited"
                              : ""
                          }}
                        </button>
                      </ng-container>
                      <ng-template #dateTime>
                        {{
                          getFormatedDate(row.visitDateTime) | date : "hh:mm a"
                        }}
                      </ng-template>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="details">
                    <th
                      style="border-right: 1px solid; text-align: center"
                      mat-header-cell
                      *matHeaderCellDef
                      aria-label="row actions"
                    ></th>
                    <td
                      style="border-right: 1px solid; text-align: center"
                      mat-cell
                      *matCellDef="let element"
                    ></td>
                  </ng-container>
                  <tr
                    class="table-header"
                    mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </section>
  </mat-step>
  <mat-step *ngIf="screenInfo === ScreenType.Mobile">
    <ng-template matStepLabel>Pending Approval 2</ng-template>
    <div
      class="user-dashboard-pending-approval-section"
      *ngIf="isShowPendingApprovalSection"
    >
      <app-pending-host-approvals
        [pendingVisitorData]="orgData.visitorDetails.visitorList"
        [screen]="screenInfo"
        (onClosePendingVisitorSection)="closeSection()"
      ></app-pending-host-approvals></div
  ></mat-step>
  <mat-step *ngIf="screenInfo === ScreenType.Mobile">
    <ng-template matStepLabel>Create a poll 3</ng-template>
    <div
      class="user-dashboard-create-event-section-mobile"
      *ngIf="isShowCreatePollSection"
    >
      <div class="user-dashboard-close-button">
        <button mat-mini-fab (click)="closeSection()">
          <mat-icon>clear</mat-icon>
        </button>
        <br />
      </div>
      <app-user-create-poll
        [userList]="orgData.orgUserList"
        [screen]="screenInfo"
        (onCreateUserPoll)="createUserPoll($event)"
      ></app-user-create-poll>
    </div>
  </mat-step>
  <mat-step *ngIf="this.screenInfo === ScreenType.Mobile">
    <ng-template matStepLabel>AumYe Community Dashboard 4</ng-template>
    <div
      class="user-dashboard-create-event-section-mobile"
      *ngIf="isShowNoticeBoardSection"
    >
      <div class="user-dashboard-close-button">
        <button mat-mini-fab (click)="closeSection()">
          <mat-icon>clear</mat-icon>
        </button>
        <br />
      </div>
      <div class="post-reports-section">
        <app-post-reports
          (postActionTaken)="onPostActionTaken($event)"
          (postFlaggedpostAction)="onPostFlaggedpostAction($event)"
          [orgPosts]="orgData.noticeBoardPosts"
          [users]="orgData.orgUserList"
          [screenInfo]="screenInfo"
          [loggedIsUsernameProfile]="loggedIsUsernameProfile"
          [currentUserId]="userId"
        >
        </app-post-reports>
      </div>
    </div>
  </mat-step>
  <mat-step *ngIf="screenInfo === ScreenType.Mobile">
    <ng-template matStepLabel>Create Event 5</ng-template>
    <div
      class="user-dashboard-create-event-section-mobile"
      *ngIf="isShowBulkInviteSection"
    >
      <div class="user-dashboard-close-button">
        <button mat-mini-fab (click)="closeSection()">
          <mat-icon>clear</mat-icon>
        </button>
        <br />
      </div>
      <app-bulk-invite
        [userEvents]="orgData.userEvents"
        [screen]="screenInfo"
        (onSendBulkInvitation)="sendBulkInvitation($event)"
      ></app-bulk-invite>
    </div>
  </mat-step>
  <mat-step *ngIf="screenInfo === ScreenType.Mobile">
    <ng-template matStepLabel>Create incident 6</ng-template>
    <div
      class="user-dashboard-create-event-section-mobile"
      *ngIf="isShowCreateManulEvent"
    >
      <div class="user-dashboard-close-button">
        <button mat-mini-fab (click)="closeSection()">
          <mat-icon>clear</mat-icon>
        </button>
        <br />
      </div>
      <div *ngIf="isLoaded">
        <app-incident-dashboard
          [dashboardData]="orgData"
          [isNotRegularFlow]="true"
        >
        </app-incident-dashboard>
      </div>
    </div>
  </mat-step>
  <mat-step *ngIf="screenInfo === ScreenType.Mobile">
    <ng-template matStepLabel>Add Gate Entry 7</ng-template>
    <div
      class="user-dashboard-create-event-section-mobile"
      *ngIf="isShowAddGateEntry"
    >
      <div class="user-dashboard-close-button">
        <button mat-mini-fab (click)="closeSection()">
          <mat-icon>clear</mat-icon>
        </button>
        <br />
      </div>
      <div *ngIf="isLoaded">
        <app-visitor-dashboard
          [dashboardData]="orgData"
          [isNotRegularFlow]="true"
        ></app-visitor-dashboard>
      </div>
    </div>
  </mat-step>
  <mat-step *ngIf="screenInfo === ScreenType.Mobile">
    <ng-template matStepLabel>Create preVerified Visitor 8</ng-template>
    <div
      class="user-dashboard-create-event-section-mobile"
      *ngIf="isPreVerifiedVisitorSection"
    >
      <div class="user-dashboard-close-button">
        <button mat-mini-fab (click)="closeSection()">
          <mat-icon>clear</mat-icon>
        </button>
        <br />
      </div>
      <div>
        <app-visitor-calendar-container></app-visitor-calendar-container>
      </div>
    </div>
  </mat-step>
</mat-stepper>

<!-- Lodge Complain Messagee -->
<ng-template #LodgeComplainDialog>
  <h2 matDialogTitle>Registering your Request</h2>
  <mat-dialog-content class="mat-dialog-content-loading">
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>

<!-- Send Bulk Invites Message -->
<ng-template #SendBulkInvitesDialog>
  <h2 matDialogTitle>Sending Invites</h2>
  <mat-dialog-content class="mat-dialog-content-loading">
    <i>Please Wait!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>

<!-- Create Poll Message -->
<ng-template #CreatePollDialog>
  <h2 matDialogTitle>Creating Poll</h2>
  <mat-dialog-content class="mat-dialog-content-loading">
    <i>Please Wait!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>

<!-- Pre Approve Message -->
<ng-template #PreApproveDialog>
  <h2 matDialogTitle>Pre-Approve Deliveries</h2>
  <mat-dialog-content class="mat-dialog-content-loading">
    <i>Please Wait!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>

<!-- Create Post Message -->
<ng-template #NoticeBoardDialog>
  <h2 matDialogTitle>Notice Board</h2>
  <mat-dialog-content class="mat-dialog-content-loading">
    <i>Posting the update!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>

<!-- Add Post Comment Message -->
<ng-template #PostCommentDialog>
  <h2 matDialogTitle>Notice Board</h2>
  <mat-dialog-content class="mat-dialog-content-loading">
    <i>Add the Comment!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>

<!-- Rapid Visitor Message -->
<ng-template #RapidVisitorScheduleDialog>
  <h2 matDialogTitle>Rapid Visitor Schedule</h2>
  <mat-dialog-content class="mat-dialog-content-loading">
    <i>Please Wait!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>

<!-- User Poll Message -->
<ng-template #UserPollDialog>
  <h2 matDialogTitle>User Poll Response</h2>
  <mat-dialog-content class="mat-dialog-content-loading">
    <i>Please Wait!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>

<!-- Security Callback Dialog Pop-Up -->
<ng-template #SecurityCallBackDialog>
  <h2 matDialogTitle>Call Security Action</h2>
  <mat-dialog-content class="mat-dialog-content-button-actions">
    <button mat-raised-button [mat-dialog-close]="true">SoS</button>
    <button
      (click)="onClickedAdvancedSos()"
      [disabled]="false"
      mat-raised-button
      mat-dialog-close
    >
      Advanced SoS
    </button>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Cancel</button>
  </mat-dialog-actions>
</ng-template>

<!-- Security Callback Dialog Pop-Up -->
<ng-template #SecuritySOSDialog>
  <div class="mat-dialog-content-sos">
    <h5 *ngIf="screenInfo === ScreenType.Mobile">
      SOS Security Callback
      <button mat-mini-fab [mat-dialog-close]="false">
        <mat-icon>clear</mat-icon>
      </button>
    </h5>
    <h3 *ngIf="screenInfo != ScreenType.Mobile">
      SOS Security Callback
      <button mat-mini-fab [mat-dialog-close]="false">
        <mat-icon>clear</mat-icon>
      </button>
    </h3>

    <mat-divider></mat-divider>
    <br />
    <div class="sos-content">
      Once Confirmed, A security team member will get in touch shortly!
    </div>
    <mat-divider></mat-divider>
  </div>
  <mat-dialog-actions>
    <!-- <button mat-raised-button >Cancel</button> -->
    <button mat-raised-button [mat-dialog-close]="true">Confirm</button>
  </mat-dialog-actions>
</ng-template>

<!-- Creating Security Call Event Message -->
<ng-template #SecurityEventDialog>
  <h2 matDialogTitle>Security Callback Event</h2>
  <mat-dialog-content class="mat-dialog-content-loading">
    <i>Please Wait!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>

<!-- User Poll Message -->
<ng-template #ClusteringVisitorDialog>
  <h2 matDialogTitle>Clustering Visitor</h2>
  <mat-dialog-content class="mat-dialog-content-loading">
    <i>Please Wait!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>
<!-- Submit Attendance Dialog Content  -->
<ng-template #SubmitAttendanceDialog>
  <h2 matDialogTitle style="text-align: center">Please wait!</h2>
  <mat-dialog-content
    style="display: flex; flex-direction: column; align-items: center"
  >
    <i>Submitting your attendance!</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>

<!-- Not Allowed Attendance Dialog Content  -->
<ng-template #ErrorAttendanceDialog>
  <h2 matDialogTitle style="text-align: center">Self Verification</h2>
  <mat-dialog-content
    style="display: flex; flex-direction: column; align-items: center"
  >
    <b
      >You are not allowed for self verification, get the permission from your
      admin</b
    >
  </mat-dialog-content>
  <mat-dialog-actions>
    <!-- <button mat-raised-button >Cancel</button> -->
    <button mat-raised-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</ng-template>
